'use es6';

import Actions from 'AdsUI/lib/Actions';
import UserRecord from 'AdsUI/records/ad-management/UserRecord';
import { List } from 'immutable';
export default ((state = List(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.USERS_FETCH_SUCCEEDED:
      return List(payload.map(e => new UserRecord(e)));

    default:
      return state;
  }
});